import { render, staticRenderFns } from "./PaymentDetailsStep.vue?vue&type=template&id=5bd0c5e2&"
import script from "./PaymentDetailsStep.vue?vue&type=script&lang=js&"
export * from "./PaymentDetailsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports